(function($) {

    $(document).on('gp_ajax_done', init_switcher)

    function init_switcher(){
        // Switch between active and inactive items in My account
        $("button.account__switcher_button").on("click", function (){
            if ($(this).hasClass("account__switcher_button-in-progress")){
                $(this).addClass("account__switcher_button-active")
                $("button.account__switcher_button-done").removeClass("account__switcher_button-active")
                $(".account__list_item-in-progress").each(function(){
                    if ($(this).hasClass("account__reminders__item")){
                        $(this).css("display","flex")
                    }
                    else {
                        $(this).show()
                    }
                })
                $(".account__list_item-done").each(function(){
                    $(this).hide()
                })
            }
            else {
                $(this).addClass("account__switcher_button-active")
                $("button.account__switcher_button-in-progress").removeClass("account__switcher_button-active")
                $(".account__list_item-in-progress").each(function(){
                    $(this).hide()
                })
                $(".account__list_item-done").each(function(){
                    if ($(this).hasClass("account__reminders__item")){
                        $(this).css("display","flex")
                    }
                    else if ($(this).hasClass("account__order")){
                        $(this).css("display","flex")
                    }
                    else {
                        $(this).show()
                    }
                })
            }
        })
    }

    // Apply coupon AJAX
    $("button.account__coupons-button").click(function() {
        const coupon_code = this.getAttribute('data-coupon-code')
        if (coupon_code){
            const $apply_btn = $(this)

            gp_ajax({
                url: ghostpress_params.ajax_url,
                type: "post",
                data: {
                    'action': 'myaccount_apply_coupon',
                    'coupon_code': coupon_code,
                }
            })
        }
    })

    init_switcher()

    // Registration reCaptcha handling
    function init_registration_recaptcha() {
        let $regForm = $("#gp-ajax-form--customer_register");
        let originalHandlers = [];
        // Only attach handler if the recaptcha widget actually exists in the DOM
        $regForm.each(function(){
            let form = this;
            let $form = $(form);
            if(!$form.find("#recaptcha-widget").length){
                return;
            }
            let originalEvent = null;

            // Use a small delay to ensure we run AFTER the core form handler has attached
            setTimeout(() => {
                // copy current handlers
                originalHandlers = [];
                ($._data(form, 'events')?.submit ?? []).forEach((h, i) => {
                    originalHandlers.push(h);
                });
                $regForm.off("submit").on("submit", function (e) {
                    e.preventDefault();
                    originalEvent = e;
                    if (typeof grecaptcha !== 'undefined') {
                        grecaptcha.execute();
                    } else {
                        console.warn('grecaptcha is not defined but widget exists.');
                    }
                });
            }, 0);

            window.onSubmitRegistrationForm = function (token) {

                originalHandlers.forEach(function(handler) {
                    handler.handler.call(form, originalEvent);
                });
                grecaptcha.reset();
            }
        })
    }

    $(document).gp_ready(init_registration_recaptcha);

    })(jQuery);